import { Box, SxProps } from '@mui/material';
import React from 'react';
import { ExerciseType, SimulatorType } from '../types';
import { getBgColor, getKSim } from '../utils/ksim';

export interface SimulatorAvatarProps {
  adHoc: boolean;
  exerciseType: ExerciseType;
  simulatorType: SimulatorType;
  sx?: SxProps;
}

const SimulatorAvatar = ({ adHoc, exerciseType, simulatorType, sx = {} }: SimulatorAvatarProps) => {
  const ksim = getKSim(exerciseType, simulatorType);

  return (
    <Box
      sx={{
        backgroundColor: getBgColor(simulatorType, adHoc),
        display: 'grid',
        height: 100,
        width: 100,
        flexShrink: 0,
        p: 1,
        placeContent: 'center',
        ...sx,
      }}
    >
      <Box component="img" src={ksim} width="100%" />
    </Box>
  );
};

export default SimulatorAvatar;
